export default __webpack_public_path__ + "static/media/atlantica_transparent_cropped.7b56aa2d.png";